// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__Gm3Gz","sliderContainer":"Slider_sliderContainer__kY1ua","helper":"Slider_helper__688Lj"};